<template>
  <div>
    <el-card style="margin-top: 15px" class="echarts">
      <v-chart :options="company_summary" :autoresize="true" />
    </el-card>
    <br/>
    <el-card style="margin-top: 15px">
      <v-chart :options="pm_summary" :autoresize="true" />
    </el-card>
    <br/>
    <el-card style="margin-top: 15px">
      <v-chart :options="product_summary" :autoresize="true" />
    </el-card>
  </div>

</template>

<script>
// import projectApi from "@/api/project";
import reqApi from "@/api/req"



export default {
  name: "requirementSummary",
  data() {
    return {
      company_summary: {
        title: [
          {
            text: 'Company/Reqs'
          }
        ],
        tooltip: {},
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
        },
        axisTick: {
          show: false
        },
        series: [
          {
            data: [],
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ]
      },
      pm_summary:{
        title: [
          {
            text: 'PM/Reqs'
          }
        ],
        tooltip: {},
        legend: {
          data: ["To Do","In Progress","Hold","Complete"],
        },
        xAxis: {
          data: [],
        },
        yAxis: {
          minInterval:1
        },
        series: [
        ],
      },
      product_summary:{
        title: [
          {
            text: 'Product/Reqs'
          }
        ],
        tooltip: {},
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          minInterval:1
        },
        axisTick: {
          show: false
        },
        series: [
          {
            data: [],
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ]
      }
    };
  },
  methods: {
    getPms(){
      reqApi.getReqPmSummary().then(
        res => {
          this.pm_summary.xAxis.data = res.data['pms']
          this.pm_summary.series = res.data['series']
        }
      )
    },
    getCompanies(){
      reqApi.getReqCompanySummary().then(
        res => {
          this.company_summary.xAxis.data = res.data['companies']
          this.company_summary.series[0].data = res.data['data']
        }
      )
    },
    getProducts(){
      reqApi.getReqProductSummary().then(
        res => {
          this.product_summary.xAxis.data = res.data['products']
          this.product_summary.series[0].data = res.data['data']
        }
      )
    }
  },
  mounted(){
    this.getCompanies()
    this.getPms()
    this.getProducts()
  },
};

</script>

<style scoped>
.echarts {
  margin: 0 auto;
  width:100%;
}
</style>
